import { render, staticRenderFns } from "./ChangeChannel.vue?vue&type=template&id=09df72a3&scoped=true"
import script from "./ChangeChannel.vue?vue&type=script&lang=js"
export * from "./ChangeChannel.vue?vue&type=script&lang=js"
import style0 from "./ChangeChannel.vue?vue&type=style&index=0&id=09df72a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09df72a3",
  null
  
)

export default component.exports